// Achata os requisitos de uma subseção (dos grupos + os sem grupo) numa lista única.
export function requisitosDaSubsecao(subsecao) {
  const doGrupos = subsecao.grupos.flatMap((g) => g.requisitos);
  return [...doGrupos, ...subsecao.requisitos_sem_grupo];
}
